import styled from '@emotion/styled'

import Button from '@/components/common/Button'

import { colors, border, transitions } from '@/styles/theme'
import { mediaUp } from '@/styles/media'
import { mediaColumns } from '@/styles/grid'
import { Text2, H3Styles, H2Styles, Text2Styles } from '@/styles/typography'
import { focusVisible } from '@/styles/mixins'

export const Wrapper = styled.div`
  margin: 20px 0 60px;

  ${mediaUp('lg')} {
    margin: 40px 0 120px;
  }
`

export const Container = styled.div`
  ${mediaColumns({ xs: [12, 0], md: [10, 1] })};
`

export const LinkContent = styled.a`
  ${focusVisible};
  padding: 20px;
  display: block;
  text-decoration: none;
  transition: box-shadow ${transitions.base};

  ${mediaUp('md')} {
    margin: 0 -20px;
  }

  ${mediaUp('lg')} {
    margin: 0 -40px;
    padding: 40px;
  }

  &:hover {
    border-radius: 16px;
    box-shadow: ${border.shadow};

    ${mediaUp('lg')} {
      border-radius: 28px;
    }
  }
`

export const NoResults = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  img {
    width: 42px;
    height: 42px;

    ${mediaUp('lg')} {
      width: 86px;
      height: 86px;
    }
  }
`

export const Title = styled.h3`
  ${H3Styles}
`

export const Breadcrumbs = styled(Text2)`
  margin: 4px 0 8px;
  color: ${colors.twilightBlue};

  ${mediaUp('lg')} {
    margin: 8px 0 20px;
  }
`

export const Text = styled(Text2)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 1.2;
  max-height: 1.2 * 2;

  a {
    ${Text2Styles};
    color: ${colors.darkSkyBlue};
  }
`

export const TextNoResults = styled.p`
  ${H2Styles};
  text-align: center;
  margin-top: 18px;

  ${mediaUp('lg')} {
    margin-top: 40px;
  }
`

export const ButtonWrapper = styled(Button)`
  margin: 20px auto 0;

  ${mediaUp('lg')} {
    margin: 40px auto 0;
  }
`
